/**
 * @file CountrySelection.jsx
 * @author Rishikesh
 * @date 2024-09-09
 * @description Component of master section to manage country
 */
import React from "react";
import {
  Button,
  Stack,
  TextField,
  Typography,
  Skeleton,
  Autocomplete,
} from "@mui/material";
import { AddNewCountry } from "./AddNewCountry";

export const CountrySelection = ({
  countryList,
  activeCountries,
  isLoading,
  selectedCountry,
  setSelectedCountry,
  setSelectedCourse,
  newCountry,
  setNewCountry,
  handleUpdateCountry = async () => {},
}) => {
  const [dialogOpen, setDialogOpen] = React.useState(false);

  const handleDialogOpen = () => setDialogOpen(true);
  const handleDialogClose = () => setDialogOpen(false);

  const handleUpdateCountryStatus = async () => {
    await handleUpdateCountry();
    handleDialogClose();
  };

  return (
    <>
      <Stack
        direction="row"
        alignItems="end"
        justifyContent="space-between"
        mb={2}
        rowGap={2}
      >
        <Stack
          direction={{ xs: "column", md: "row" }}
          alignItems={{ xs: "flex-start", md: "center" }}
          gap={2}
        >
          {isLoading ? (
            <Skeleton variant="rounded" width={490} height={24} />
          ) : (
            <Typography fontWeight={700} fontSize={24} color="#222222">
              Select Country
            </Typography>
          )}
          {!isLoading && (
            <Autocomplete
              id="combo-box-demo"
              size="small"
              options={countryList}
              getOptionLabel={(option) => option.country_name}
              value={
                countryList.find((option) => option.id === selectedCountry) ||
                null
              }
              onChange={(event, newValue) => {
                setSelectedCountry(newValue?.id || "");
                setSelectedCourse({});
              }}
              sx={{
                width: { xs: 200, md: 300 },
                mt: 1,
                "& .MuiOutlinedInput-root": { borderRadius: "12px" },
              }}
              renderInput={(params) => (
                <TextField {...params} label="Select country" color="black" />
              )}
            />
          )}
        </Stack>
        {isLoading ? (
          <Skeleton variant="rounded" width={180} height={40} />
        ) : (
          <Button
            variant="outlined"
            sx={{ borderRadius: "12px" }}
            onClick={handleDialogOpen}
          >
            Manage Country
          </Button>
        )}
      </Stack>
      <AddNewCountry
        newCountry={newCountry}
        setNewCountry={setNewCountry}
        countryList={countryList}
        dialogOpen={dialogOpen}
        handleDialogClose={handleDialogClose}
        handleUpdateCountryStatus={handleUpdateCountryStatus}
      />
    </>
  );
};
